var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkRightStatus(15))?_c('v-list-item',{on:{"click":function($event){return _vm.deleteDonor(_vm.donor)}}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("buttons.delete")))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }